export enum ToasterEnum {
    SUCCESS,
    INFO,
    ERROR,
    WARNING,
}
